import React from 'react';
import { CssBaseline } from '@mui/material';
import { useRoutes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import RTL from './layouts/full/shared/customizer/RTL';
import ScrollToTop from './components/shared/ScrollToTop';
import Router from './routes/Router';
import "./App.css";
function App() {
  const routing = useRoutes(Router());
  const customizer = useSelector((state) => state.customizer);

  return (
    <RTL direction={customizer.activeDir}>
      <CssBaseline />
      <ScrollToTop>{routing}</ScrollToTop>
    </RTL>
  );
}


export default App;
